import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

const BackButton = ({ to, label = 'Back', className = '' }) => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      // Try to go back in history, or go to home
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate('/');
      }
    }
  };
  
  return (
    <Button
      variant="ghost"
      onClick={handleBack}
      className={`text-gray-600 hover:text-navy hover:bg-gray-100 font-medium ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4 mr-2" />
      {label}
    </Button>
  );
};

export default BackButton;
